import { defineComponent, ref } from 'vue'
import { hostForImage } from '@/const'
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import './style.sass'
import EmptyList from '@/components/empty-list/index'

export default defineComponent({
  props: {
    documentsItems: {
      type: Array,
      default: () => []
    }
  },
  setup (props: any) {
    const showAllOrderInfo = ref({ active: false, id: 0 })

    function showAllInfo (id: number) {
      showAllOrderInfo.value.active = true
      showAllOrderInfo.value.id = id
    }

    function getDateOrder (val: string) {
      return dayjs(val).locale('ru').format('D MMM')
    }

    function getDate (val: string) {
      return dayjs(val).locale('ru').format('DD.MM.YYYY')
    }

    function statusFilter (val: any) {
      if (!val) return
      if (val.filter((item: any) => item.status.name === 'payment').length > 0) return true
      else return false
    }

    return () => (
      <div class="documents-items">
        {props.documentsItems.length > 0 ? (
          props.documentsItems.map((item: any, id: number) => (
            <div class="document-item">
              <div class="document-name">
                <div class="document-content">
                  <p>{ item.nameForSite ? item.nameForSite : item.name }</p>
                </div>
              </div>
              <div class="document-date">
                <p>Дата загрузки: {getDate(item.createdAt)}</p>
              </div>
              <a target="_blank" href={`${hostForImage}${item.path}`}>
                <img class="document-download" src={require('@/assets/download.svg')}/> Скачать
              </a>
            </div>
          )))
          : (<EmptyList/>)}
      </div>
    )
  }
})